// import React, { useEffect, useState } from "react";
// import { connect } from "react-redux";
// import { RootState } from "../../../redux/rootReducers";
// import {
//   gstOneProceesFileAction,
//   postGstrOneFilingMappingAction,
//   postGstrOneFilingSendOTPAction,
//   postGstrOneCompleteFilingAction,
//   postGstrThreeBFilingMappingAction,
//   resetGstFilingError,
//   resetGstFilingMessage,
//   resetGstFilingSuccess,
//   resetGstModuleError,
// } from "../../../redux/gstModule";
// import {
//   PostGstrProceedAndMappingPayload,
//   GstrFilingSendOTPPayload,
//   PostGstrOneCompleteFiling,
// } from "../../../commonTypes/gstTypes";
// import { OptionsType } from "../../../commonTypes/universalTypes";
// import { getMonthNumber } from "../../../utils/commonFunctions";
// import {
//   CollapseClose,
//   CollapseOpen,
//   RedErrorIcon,
// } from "../../../assets/images";
// import "./GstThreeBFiling.scss";
// import { Progress } from "reactstrap";
// import { GstrOneAutoFilledTable } from "../../../components/Gst";
// import { ErrorSuccessModal, Loader } from "../../../components/commons";
// import { resetSession } from "../../../redux/auth";
// type AppProps = {
//   history: any;
//   // handleFillGstToggle: () => void;

//   dispatchGstrThreeBFilingMaping: (
//     data: PostGstrProceedAndMappingPayload
//   ) => void;
//   token: string | null;
//   success: number | null;
//   gstFillingSuccess: number | null;
//   error: any;
//   gstError: any;
//   statusCode: number | null;
//   fetching: boolean;
//   message: string | null;
//   clientCode: number | string;
//   financialYear: OptionsType;
//   month: OptionsType;
//   dispatchGstrOneFilingSendOTP: (data: GstrFilingSendOTPPayload) => void;
//   dispatchResetGstFilingError: () => void;
//   dispatchResetGstFilingSuccess: () => void;
//   dispatchGstrThreeBComleteFiling: (data: PostGstrOneCompleteFiling) => void;
//   dispatchResetSession: () => void;
//   dispatchResetGstModuleError: () => void;
//   dispatchResetGstFilingMessage: () => void;
//   dispatchGstThreeBFiling: (data: PostGstrProceedAndMappingPayload) => void;
//   gstFetching: boolean;
// };

// const GstThreeBFiling = ({
//   // handleFillGstToggle,
//   // gstin,
//   dispatchGstrThreeBFilingMaping,
//   token,
//   success,
//   error,
//   statusCode,
//   fetching,
//   message,
//   // clientCode,
//   // financialYear,
//   // month,
//   dispatchGstrOneFilingSendOTP,
//   dispatchResetGstFilingError,
//   dispatchResetGstFilingSuccess,
//   gstFillingSuccess,
//   dispatchGstrThreeBComleteFiling,
//   history,
//   dispatchResetSession,
//   dispatchResetGstModuleError,
//   dispatchResetGstFilingMessage,
//   dispatchGstThreeBFiling,
//   gstFetching,
//   gstError,
// }: AppProps) => {
//   const clientCode = history?.location?.state?.clientCode;
//   const gstin = history?.location?.state?.gstin;
//   const financialYear = history?.location?.state?.financialYear;
//   const month = history?.location?.state?.month;
//   const [isSummaryCollapsed, setIsSummaryCollapsed] = useState(false);
//   const [progressValue, setProgressValue] = useState(0);

//   const [step, setStep] = useState(0);
//   const [otp, setOtp] = useState("");

//   useEffect(() => {
//     dispatchResetGstFilingError();
//     dispatchResetGstFilingMessage();
//     dispatchResetGstFilingSuccess();
//   }, []);

//   useEffect(() => {
//     let monthData = month?.value?.split("-")?.[0];
//     let finalData = {
//       token,
//       client_code: clientCode,
//       gstin: gstin?.gstIn,
//       year: financialYear?.value,
//       month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
//         getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
//       }`,
//     };
//     // dispatchGstrThreeBFilingMaping(finalData);
//   }, []);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (fetching && gstFillingSuccess === null) {
//         if (progressValue > 70) {
//           setProgressValue(89);
//           return;
//         } else if (progressValue < 100) {
//           setProgressValue((prev) => prev + 10);
//         }
//       } else if (
//         !fetching &&
//         (gstFillingSuccess === 0 || gstFillingSuccess === 1)
//       ) {
//         setProgressValue(100);
//       }
//     }, 1000);

//     return () => clearTimeout(interval);
//   }, [fetching, gstFillingSuccess, progressValue]);

//   useEffect(() => {
//     if (message === "GSTR-3b Filling Process Completed Successfully ") {
//       dispatchResetGstFilingError();
//       dispatchResetGstFilingMessage();
//       setStep(1);
//     }
//   }, [message]);

//   useEffect(() => {
//     if (message === "OTP for GSTR-3b verified successfully") {
//       dispatchResetGstFilingError();
//       dispatchResetGstFilingMessage();
//       setStep(3);
//     }
//   }, [message]);

//   const handleShowSummary = () => {
//     setIsSummaryCollapsed(!isSummaryCollapsed);
//   };

//   const handleFillGstOtp = () => {
//     setStep(2);
//     handleAddOTP();
//   };

//   const handleAddOTP = () => {
//     let monthData = month?.value?.split("-")?.[0];
//     let finalData = {
//       token,
//       gstin: gstin?.gstIn,
//       client_code: clientCode,
//       year: financialYear?.value,
//       month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
//         getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
//       }`,
//       gstr_type: "GSTR3b",
//     };
//     dispatchGstrOneFilingSendOTP(finalData);
//   };

//   const handleVerifyOTP = () => {
//     let monthData = month?.value?.split("-")?.[0];
//     let finalData = {
//       evc_otp: otp,
//       gstin: gstin?.gstIn,
//       client_code: clientCode,
//       token,
//       year: financialYear?.value,
//       month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
//         getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
//       }`,
//       // gstr_type: "GSTR3b",
//     };
//     dispatchGstrThreeBComleteFiling(finalData);
//   };

//   const handleErrorModal = () => {
//     if (success === 0) {
//       if (statusCode === 401) {
//         return (
//           <ErrorSuccessModal
//             type="error"
//             isOpen={!!error}
//             title="Error"
//             message={error}
//             buttonText="Logout"
//             onPress={() => {
//               dispatchResetSession();
//             }}
//             statusCode={statusCode}
//           />
//         );
//       }

//       if (
//         gstError &&
//         gstError === "You're Not Authorized. Please contact admin!"
//       ) {
//         return (
//           <ErrorSuccessModal
//             type="error"
//             isOpen={!!gstError}
//             title="Error"
//             message="You're Not Authorized. Please contact admin!"
//             buttonText="OK"
//             statusCode={statusCode}
//             onPress={() => {
//               dispatchResetGstFilingError();
//               dispatchResetGstFilingSuccess();
//               dispatchResetGstFilingMessage();
//             }}
//           />
//         );
//       }
//     } else if (message === "GST File Proceeded Successfully" && success === 1) {
//       return (
//         <ErrorSuccessModal
//           type="success"
//           isOpen={success === 1}
//           title="Success"
//           message={`GST File Proceeded Successfully`}
//           buttonText="OK"
//           onPress={() => {
//             history.push({
//               pathname: `/gst/gstr-threeB/${clientCode}`,
//             });
//           }}
//           statusCode={statusCode}
//         />
//       );
//     }
//     return false;
//   };

//   const ErrorDisplay = ({ item }: any) => {
//     const errorKeys = Object.keys(item?.errors || {});

//     return (
//       <>
//         <div
//           className="mt-3 text-left"
//           style={{ fontSize: "15px", fontWeight: 600 }}
//         >
//           {item?.invoice_number ? item?.invoice_number : item?.invoice_type}
//         </div>
//         <div className="text-left">
//           {errorKeys?.length ? (
//             errorKeys?.map((key) => {
//               return (
//                 <>
//                   <div
//                     className="mt-2 mb-2 error-msg p-2"
//                     style={{
//                       border: "1px solid #ba4916",
//                       backgroundColor: "#fef2ed",
//                       borderRadius: "6px",
//                       width: "fit-content",
//                     }}
//                     key={key}
//                   >
//                     <span className="mr-1">
//                       <img src={RedErrorIcon} alt="error" />
//                     </span>
//                     <span>
//                       {key}:={item.errors[key]}
//                     </span>
//                   </div>
//                 </>
//               );
//             })
//           ) : (
//             <div>No errors</div>
//           )}
//         </div>
//       </>
//     );
//   };

//   const errorCounts =
//     error && Array.isArray(error) && error?.length
//       ? error?.map((invoice: any) => {
//           return {
//             invoice_number: invoice?.invoice_number,
//             errorCount: Object.keys(invoice?.errors)?.length,
//           };
//         })
//       : [];

//   const totalErrorCount = errorCounts?.reduce(
//     (acc, invoice) => acc + invoice?.errorCount,
//     0
//   );

//   const handleFinalFilling = () => {
//     let monthData = month?.value?.split("-")?.[0];
//     let finalData = {
//       token,
//       client_code: clientCode,
//       gstin: gstin?.gstIn,
//       year: financialYear?.value,
//       month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
//         getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
//       }`,
//       gst_type: "GSTR3b",
//     };

//     // dispatchGstThreeBFiling(finalData);
//   };

//   function errorShow() {
//     return (
//       <>
//         {Array.isArray(error) && error?.length ? (
//           <>
//             <div className="mt-4" style={{ fontSize: "18px", fontWeight: 500 }}>
//               List of Error Occurred in this GSTR-3b Form
//             </div>
//             {message === "Error in inserting Purchase Invoice Data" ? (
//               <div className="mt-3 mb-3" style={{ color: "#6e7491" }}>
//                 Total {totalErrorCount} errors found in {error?.length}{" "}
//                 Invoices. Please fix all errors to proceed with GSTR-3b Filing.
//               </div>
//             ) : (
//               ""
//             )}
//           </>
//         ) : (
//           ""
//         )}

//         {error && Array.isArray(error) && error?.length ? (
//           error?.map((item: any) => {
//             return (
//               <>
//                 <ErrorDisplay item={item} />
//               </>
//             );
//           })
//         ) : error?.length ? (
//           <>
//             <div className="mt-4" style={{ fontSize: "18px", fontWeight: 500 }}>
//               List of Error Occurred in this GSTR-3b Form
//             </div>

//             <div
//               className="mt-2 mb-2 error-msg p-2"
//               style={{
//                 border: "1px solid #ba4916",
//                 backgroundColor: "#fef2ed",
//                 borderRadius: "6px",
//                 width: "fit-content",
//               }}
//             >
//               <span className="mr-1">
//                 <img src={RedErrorIcon} alt="error" />
//               </span>
//               <span>{error}</span>
//             </div>
//           </>
//         ) : (
//           ""
//         )}
//       </>
//     );
//   }

//   const body = () => {
//     return (
//       <>
//         <div
//           className="p-2 m-3"
//           style={{
//             border: "solid 1px #bfcbe1",
//             borderRadius: "5px",
//             cursor: "pointer",
//           }}
//           onClick={handleShowSummary}
//         >
//           <img
//             src={isSummaryCollapsed ? CollapseOpen : CollapseClose}
//             alt="collapse"
//           />
//           Summary
//           {isSummaryCollapsed ? (
//             <GstrOneAutoFilledTable data={gstin} gst />
//           ) : (
//             ""
//           )}
//         </div>

//         <div className="steps-container mt-4">
//           <div className="step mr-3">
//             <div
//               className="step-number"
//               style={{
//                 background: step === 0 || step === 1 ? "#dd4433" : "",
//                 color: step === 0 || step === 1 ? "white" : "",
//               }}
//             >
//               01
//             </div>
//             <div
//               className="step-title"
//               style={{
//                 color: step === 0 || step === 1 ? "#dd4433" : "",
//               }}
//             >
//               Map Invoices To GSTR-3b
//             </div>
//           </div>
//           <div className="step-line"></div>
//           <div className="step ml-3 mr-3">
//             <div
//               className="step-number"
//               style={{
//                 background: step === 2 ? "#dd4433" : "",
//                 color: step === 2 ? "white" : "",
//               }}
//             >
//               02
//             </div>
//             <div
//               className="step-title"
//               style={{
//                 color: step === 2 ? "#dd4433" : "",
//               }}
//             >
//               Verify GSTR-3b With OTP
//             </div>
//           </div>
//           <div className="step-line"></div>
//           <div className="step ml-3">
//             <div
//               className="step-number"
//               style={{
//                 background: step === 3 ? "#dd4433" : "",
//                 color: step === 3 ? "white" : "",
//               }}
//             >
//               03
//             </div>
//             <div
//               className="step-title"
//               style={{
//                 color: step === 3 ? "#dd4433" : "",
//               }}
//             >
//               File Your GSTR-3b
//             </div>
//           </div>
//         </div>

//         <div
//           className="mr-3 ml-3 mt-5"
//           style={{
//             minHeight: "70vh",
//             border: "solid 1px #bfcbe1",
//             backgroundColor: "#f7f8f9",
//           }}
//         >
//           {step === 1 || step === 0 ? (
//             <div
//               className=" p-4 text-center"
//               style={{ width: "40%", margin: "auto" }}
//             >
//               <h1>Step 01 : Map Invoices to GSTR-3b</h1>
//               <div
//                 style={{ fontSize: "20px", fontWeight: 500 }}
//                 className="mt-5"
//               >
//                 We are mapping your invoices to your GSTR-3b Report. Please wait
//                 until the process is complete. <br></br>Once mapping is
//                 complete, click the button below to file GSTR-3b.
//               </div>
//               <div className="mt-5 d-flex justify-content-center">
//                 <Progress
//                   striped
//                   style={{
//                     height: "15px",
//                     marginRight: "10px",
//                     width: "70%",
//                     backgroundColor: "#bfcbe1",
//                   }}
//                   value={progressValue}
//                   // max={item?.total_status}
//                   color={"success"}
//                 ></Progress>
//               </div>
//               <div
//                 style={{ width: "70%", margin: "auto" }}
//                 className="text-right mt-2 text-success"
//               >
//                 {progressValue} %
//               </div>
//               <button
//                 className="btn btn-primary"
//                 disabled={
//                   (step === 0 && fetching) ||
//                   Array.isArray(error) ||
//                   fetching ||
//                   error
//                 }
//                 onClick={() => {
//                   handleFillGstOtp();
//                 }}
//               >
//                 File GSTR-3b with OTP
//               </button>
//               {errorShow()}
//             </div>
//           ) : step === 2 ? (
//             <div
//               className=" p-4 text-center"
//               style={{ width: "40%", margin: "auto" }}
//             >
//               <h1>Step 02 : Verify GSTR-3b with OTP</h1>
//               <div
//                 style={{ fontSize: "20px", fontWeight: 500 }}
//                 className="mt-5"
//               >
//                 We have sent OTP on registered number. Please enter OTP below to
//                 File GSTR-3b.
//               </div>
//               <div className="d-flex justify-content-center mt-3">
//                 <input
//                   type="number"
//                   placeholder="Enter OTP here"
//                   className="form-control"
//                   style={{ width: "290px" }}
//                   disabled={
//                     message?.includes(
//                       `You can't send OTP for more than 3 times. Please try after 1 hour!`
//                     ) ||
//                     message?.includes(
//                       `OTP for GSTR-3b not fetched successfully`
//                     )
//                   }
//                   onChange={(e: any) => {
//                     setOtp(e.target.value);
//                     dispatchResetGstFilingMessage();
//                   }}
//                   onWheel={(event) => event.currentTarget.blur()}
//                 />
//               </div>
//               <button
//                 className="btn btn-primary text-center"
//                 style={{ marginTop: "22px" }}
//                 onClick={() => handleVerifyOTP()}
//               >
//                 Submit
//               </button>

//               <div className="mt-2">
//                 {message?.includes(
//                   `You can't send OTP for more than 3 times. Please try after 1 hour!`
//                 ) ? (
//                   <small
//                     className="text-danger mt-2"
//                     style={{ fontSize: "14px" }}
//                   >
//                     You can't send OTP for more than 3 times. Please try after 1
//                     hour!
//                   </small>
//                 ) : message?.includes(
//                     `OTP for GSTR-3b not fetched successfully`
//                   ) ? (
//                   <small
//                     className="text-danger mt-2"
//                     style={{ fontSize: "14px" }}
//                   >
//                     OTP for GSTR-3b not fetched successfully
//                   </small>
//                 ) : message?.includes(
//                     `OTP for GSTR-3b not verified successfully`
//                   ) ? (
//                   <small
//                     className="text-danger mt-2"
//                     style={{ fontSize: "14px" }}
//                   >
//                     OTP for GSTR-3b not verified successfully
//                   </small>
//                 ) : (
//                   ""
//                 )}
//               </div>
//               {errorShow()}
//             </div>
//           ) : (
//             <div
//               className=" p-4 text-center"
//               style={{ width: "40%", margin: "auto" }}
//             >
//               <h1>Step 03 : File Your GSTR-3b</h1>
//               <div
//                 style={{ fontSize: "20px", fontWeight: 500 }}
//                 className="mt-5"
//               >
//                 Your OTP is verified successfully, please click on button below
//                 to file your GSTR-3b.
//               </div>

//               <button
//                 className="btn btn-primary mt-4"
//                 onClick={handleFinalFilling}
//               >
//                 File GSTR-3B
//               </button>
//               {errorShow()}
//             </div>
//           )}
//         </div>
//       </>
//     );
//   };
//   return (
//     <div className="new-table-card p-4">
//       {body()}
//       {handleErrorModal()}

//       {gstFetching && <Loader />}
//     </div>
//   );
// };

// const mapStateToProps = (state: RootState) => ({
//   token: state.auth.token,
//   fetching: state.gst.gstFilllingFetching,
//   error: state.gst.gstFillingError,
//   gstFillingSuccess: state.gst.gstFillingSuccess,
//   success: state.gst.success,
//   message: state.gst.gstFillingMessage,
//   statusCode: state.gst.gstFillingStatusCode,
//   gstFetching: state.gst.fetching,
//   gstError: state.gst.error,
// });

// const mapDispatchToProps = (dispatch: any) => ({
//   dispatchGstrThreeBFilingMaping: (data: PostGstrProceedAndMappingPayload) =>
//     dispatch(postGstrThreeBFilingMappingAction(data)),
//   dispatchGstrOneFilingSendOTP: (data: GstrFilingSendOTPPayload) => {
//     dispatch(postGstrOneFilingSendOTPAction(data));
//   },
//   dispatchResetGstFilingError: () => dispatch(resetGstFilingError()),
//   dispatchResetGstFilingSuccess: () => dispatch(resetGstFilingSuccess()),

//   dispatchGstrThreeBComleteFiling: (data: PostGstrOneCompleteFiling) => {
//     dispatch(postGstrOneCompleteFilingAction(data));
//   },

//   dispatchResetSession: () => dispatch(resetSession()),
//   dispatchResetGstModuleError: () => dispatch(resetGstModuleError()),
//   dispatchResetGstFilingMessage: () => dispatch(resetGstFilingMessage()),
//   dispatchGstThreeBFiling: (data: PostGstrProceedAndMappingPayload) =>
//     dispatch(gstOneProceesFileAction(data)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(GstThreeBFiling);
import React from "react";

const GstThreeBFiling = () => {
  return <div>GstThreeBFiling</div>;
};

export default GstThreeBFiling;
